/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, {  lazy, Suspense } from "react";
import './App.css';

const Navbar = lazy(() =>
  import("./components/Navbar")
);
const Header = lazy(() =>
  import("./components/Header")
);
const Body = lazy(() =>
  import("./components/Body")
);
const Contact = lazy(() =>
  import("./components/ContactUs")
);
const SubFooter = lazy(() =>
  import("./components/SubFooter")
);
const Footer = lazy(() =>
  import("./components/Footer")
);

function App() {

  return (
    <>
    <Suspense fallback={<div />}>
    <Navbar/>
    </Suspense>
    <Suspense fallback={<div />}>
      <Header />
      </Suspense>
      <Suspense fallback={<div />}>
      <Body />
      </Suspense>
      <Suspense fallback={<div />}>
      <Contact />
      </Suspense>
      <Suspense fallback={<div />}>
      <SubFooter />
      </Suspense>
      <Suspense fallback={<div />}>
      <Footer />
      </Suspense>
    </>
  );
}

export default App;
